import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { HousingUnitService } from 'app/services/housingunit-service';
import { IWaterSystem } from 'app/models/water-systems/water-system';
import { AuthService } from '@shared/auth/auth.service';

/*
 * Edit Associated Housing Unit Dialog
 */
@Component({
  selector: 'water-system-edit',
  templateUrl: 'water-system-edit-dialog.html',
  styleUrls: ['./water-system-edit-dialog.scss']
})
export class DialogEditHousingUnitWaterSystemComponent implements OnInit {
  @Input('housingUnitId')
  housingUnitId: number = 0;
  @Input('waterSystemId')
   waterSystemId: number = 0;

   loading: boolean = false;
  processing: boolean = false;

  waterSystem: IWaterSystem = {
    active: true,
    comments: '',
    createDate: '',
    createdby: '',
    endDate: '',
    housingUnitId: 0,
    id: 0,
    lastUpdated: '',
    lastUpdatedBy: '',
    name: '',
    startDate: ''
  }

  waterSystemForm = new FormGroup({
    id: new FormControl(this.waterSystemId),
    // startDate: new FormControl(),
    // endDate: new FormControl(),
    comments:  new FormControl(''),
    name:  new FormControl(''),
    active:  new FormControl(true)
  });

  constructor(
    public oregonWellDataService: OregonWellDataService,
    public housingUnitService: HousingUnitService,
    public authService: AuthService,  
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: number[],
    private dialogRef: MatDialogRef<DialogEditHousingUnitWaterSystemComponent>
    ) {
    this.housingUnitId = this.data['housingUnitId'];
    this.waterSystemId = this.data['waterSystemId'];
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    if (this.waterSystemId <= 0) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.housingUnitService.getHousingUnitWaterSystemById(this.waterSystemId).subscribe(
      result => {
        this.waterSystem = result;
        this.setFormValues();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }


  save() {    
    // this.processing = true;
    this.waterSystem.housingUnitId = this.housingUnitId;
    this.waterSystem.id = this.waterSystemId;

    this.waterSystem.comments = this.waterSystemForm.get('comments').value;
    this.waterSystem.name = this.waterSystemForm.value.name;
    this.waterSystem.active = this.waterSystemForm.value.active;
    
    this.housingUnitService.saveHousingUnitWaterSystem(this.waterSystem).subscribe(
      result => {
        this.toastr.success("Housing Unit Water System Saved");
        this.processing = false;
      },
      error => {
        this.processing = false;
        this.toastr.error("Unable to Save Housing Unit Water System");
      },
      () => {
        this.dialogRef.close();
      }
    );
  }

  setFormValues() {
    // if(this.waterSystem.startDate != null) {
    //   this.waterSystemForm.get("startDate").setValue((new Date(this.waterSystem.startDate)));
    // }
    // if(this.waterSystem.endDate != null) {
    //   this.waterSystemForm.get("endDate").setValue((new Date(this.waterSystem.endDate)));
    // }
    this.waterSystemForm.get("comments").setValue(this.waterSystem.comments);
    this.waterSystemForm.get("name").setValue(this.waterSystem.name);
    this.waterSystemForm.get("active").setValue(this.waterSystem.active);
  }

  
}